export {
  STAGE_IDS,
  STAGES,
  STAGE_BY_ID,
  DEFAULT_THRESHOLDS,
  computeStage,
  daysBetween,
  lifecycleOf,
  LIFECYCLE_LABELS,
  type Lifecycle,
  type StageId,
  type StageMeta,
  type StageSeverity,
  type StageFacts,
  type StageThresholds,
} from './stages'

export {
  AGE_BANDS,
  ageBandFor,
  tallyAgeBands,
  type AgeBand,
  type AgeBandId,
  type AgeTally,
} from './age'

export {
  computeTrainingMetrics,
  type SessionLike,
  type TrainingMetrics,
} from './metrics'

export {
  normalizeEmail,
  normalizePhone,
  matchKeys,
  type IdentitySource,
  type IdentityCandidate,
  type MatchKey,
} from './identity'

export {
  BUCKET_FIELDS,
  evaluateRule,
  orderMatches,
  describeRule,
  ruleMentionsField,
  ruleWantsHidden,
  HIDDEN_FIELDS,
  STARTER_BUCKETS,
  type BucketField,
  type BucketRule,
  type BucketSubject,
  type BucketDefinition,
  type Comparison,
  type OrderMatch,
  type OrderSubject,
} from './buckets'

export const CHANNELS = ['direct_web', 'optometrist', 'referral', 'paid_ads', 'unknown'] as const
export type Channel = (typeof CHANNELS)[number]

export const CHANNEL_LABELS: Record<Channel, string> = {
  direct_web: 'Direct web',
  optometrist: 'Optometrist',
  referral: 'Referral',
  paid_ads: 'Paid ads',
  unknown: 'Unattributed',
}

export {
  GRADES,
  GRADE_LABELS,
  GRADE_RULE_VERSION,
  STANDARD_QUESTIONS,
  gradePrescription,
  decidingPrescription,
  type Grade,
  type EyeRx,
  type PrescriptionFacts,
  type GradeReason,
  type GradeResult,
} from './eligibility'

export {
  FUNNEL_STEPS,
  FUNNEL_NORMAL_DAYS,
  GRID_KIT,
  GRID_PRESCRIPTION,
  computeFunnel,
  gridCell,
  type FunnelStepId,
  type FunnelTrack,
  type FunnelFacts,
  type FunnelExit,
  type PersonFunnel,
  type StepState,
  type GridKit,
  type GridPrescription,
} from './funnel'
